import { SectionLoader } from '@/shared/components/section-loader';

export default function Loading() {
  return (
    <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-neutral-light-300">
      <SectionLoader withLabel size="m" />
    </div>
  );
}
